import { useState, useEffect } from "react";
import { getAllSectionType } from "../../utils/ConstantsURL";

export const useGetAllSectionType = (token) => {
  const [AllSectionTypes, setAllSectionTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAllSectionTypes = async () => {
      if (!token) return;

      setLoading(true);
      setError(null);

      try {
        const response = await fetch(getAllSectionType(), {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`Error ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();

        const transformedData = data.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        setAllSectionTypes(transformedData);
      } catch (error) {
        console.error("Error fetching AllSectionTypes:", error);
        setError(error.message);
        setAllSectionTypes([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAllSectionTypes();
  }, [token]);

  return {
    AllSectionTypes,
    loading,
    error,
  };
};
